<template>
  <List :hideBackBtn="true" color="grey lighten-3" :autofocus="false" />
</template>

<script>
import List from "@/modules/Delivery/components/List.vue";
export default {
  components: {
    List,
  },
};
</script>

<style scoped>
</style>